import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import Table from '../../../../../../components/table/Table';


export default class Damaged extends Component {
    render() {
        if (this.props.details.length > 0) {
            return (
                <Row>
                    <Col md="12">
                        <Table responsive className="table--bordered hpi" style={this.props.style}>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Description</th>
                                    <th>Date Recorded</th>
                                    <th>Condition Type</th>
                                    <th>Condition Date</th>
                                    <th>Amendment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.props.details.map((item, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{item.theft_indicator}</td>
                                        <td>{item.miaftr_entry_date}</td>
                                        <td>{item.loss_type}</td>
                                        <td>{item.loss_date}</td>
                                        <td>{item.date_of_transaction}</td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </Col>
                </Row>
            );
        }
        return (<Row><Col md="12"><p>There are no records about any finance agreements</p></Col></Row>);
    }
}

Damaged.propTypes = {
    details: PropTypes.array.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/HPI_components/damaged.js